import { Params } from '@angular/router';

export const STUDENT_QUESTION_ATTEMPT_ROUTE = {
  name: 'studentquestionattempt/:attemptId/:itemOrder',
  route(attemptId: string, itemOrder: number): string[] {
    return ['/', 'student-question-attempt', attemptId, itemOrder.toString()];
  },
  queryParams(isSingleChoice: boolean | null = null,
              hideName: boolean | null = null,
              isTeacher: boolean | null = null,
              hideActions: boolean | null = null,
              isDemo: boolean | null = null): Params {
    return {
      isSingleChoice,
      hideName,
      isTeacher,
      hideActions,
      isDemo
    };
  },
};
